<template>
    <router-view/>
</template>
<script>
export default {
  created () {
    // 如果是阳西就不需要check login
    if (
      this.$route.name !== 'yangxiData' &&
      this.$route.name !== 'xvData' &&
      this.$route.name !== 'hzLitchi' &&
      this.$route.name !== 'home' &&
      this.$route.name !== 'nationDetail'
    ) {
      this.$store.dispatch('user/geUserinfo', true)
    } else {
      this.$store.dispatch('user/geUserinfo', false)
    }
    this.$store.dispatch('right/getDates')
    this.$store.dispatch('right/getProvince')
    this.$store.dispatch('right/getCounty', { provinceId: this.$route.query.province_id })
  }
}
</script>
<style lang="less">
html,
body {
  height: 100%;
  overflow: hidden;
  font-family: 'Microsoft YaHei';
}
#app {
  height: 100%;
  overflow: hidden;
}
.height100 {
  height: 100%;
  overflow: auto;
}
.height100_hidden {
  height: 100%;
  overflow: hidden;
}
* {
  box-sizing: border-box;
}
.pull_left {
  float: left;
}
.pull_right {
  float: right;
}
[v-cloak] {
  display: none;
}
.inline_block {
  display: inline-block;
}
.clearfix:after {
  content: '';
  display: block;
  clear: both;
}
.text_center {
  text-align: center;
}
.text_left {
  text-align: left;
}
.text_right {
  text-align: right;
}
.pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flexV {
  display: flex;
  flex-direction: column;
}
.flex1 {
  flex: 1;
}
.left {
  width: 350px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  background-color: #1b212a;
}
.anchorBL {
  display: none;
}
.BMap_stdMpPan {
  display: none;
}
.BMap_stdMpZoom {
  top: 16px !important;
}
.font_12 {
  font-size: 12px;
}
.font_14 {
  font-size: 14px;
}
.font_16 {
  font-size: 16px;
}
.font_18 {
  font-size: 18px;
}
.font_20 {
  font-size: 20px;
}
.font_22 {
  font-size: 22px;
}
.font_24 {
  font-size: 24px;
}
.font_26 {
  font-size: 26px;
}
.font_28 {
  font-size: 28px;
}
.left {
  color: #fff;
  padding: 0 20px;
  box-sizing: border-box;
  .line0 {
    height: 28px;
    .txt0 {
      font-size: 20px;
      margin-right: 8px;
      vertical-align: bottom;
    }
    .txt1 {
      font-size: 16px;
      vertical-align: bottom;
    }
    .back_btn {
      color: #fff;
      text-decoration: none;
      font-size: 10px;
      background-color: #3f4854;
      background-image: url(//img.yimutian.com/crm/5bcc2e3764008157d9496f0d65021f07.png);
      background-repeat: no-repeat;
      background-position: 4px center;
      background-size: auto 70%;
      padding: 4px 4px 4px 20px;
      border-radius: 2px;
      margin-top: 4px;
      cursor: pointer;
    }
  }
  .line1 {
    background-color: #28303f;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 10px 0;
    margin: 28px 0;
    .line1_col {
      border-right: 1px solid #ffffff;
      &:last-child {
        border-right: 1px solid #28303f;
      }
      .txt0 {
        line-height: 40px;
        padding-left: 14px;
        text-align: center;
      }
      .txt1 {
        font-size: 12px;
        padding-left: 10px;
        line-height: 20px;
      }
      .home_line1_col1 {
        font-size: 12px;
        padding-right: 20px;
        line-height: 20px;
      }
    }
  }
  .line2 {
    text-align: center;
    margin-bottom: 18px;
    .tag {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      color: #828282;
      background-color: #1b212a;
      border: 1px solid #2f353f;
      border-radius: 2px;
      &.active {
        background-color: #28303f;
        border: 1px solid #2f353f;
        border-radius: 2px;
        color: #fff;
      }
    }
    .tag0 {
      margin-right: 1px;
    }
    .tag1 {
      margin-left: 1px;
    }
  }
  .list_ctn {
    margin: 0 -20px;
    padding: 16px 36px;
    padding-left: 8px;
    background-color: #202630;
    direction: rtl;
    overflow: hidden;
  }
  .list_srcoll {
    height: 100%;
    overflow: auto;
    padding-left: 28px;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      border: 3px solid #202630;
      background-color: #2f353f;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #2f353f;
    }
  }
  .list_header {
    font-size: 12px;
    color: #686f7f;
    line-height: 18px;
    padding-bottom: 16px;
    direction: ltr;
    &:after {
      display: block;
      background-color: #323b48;
      height: 1px;
      width: 394px;
      margin-left: -10px;
      transform: translateY(16px);
    }
  }
  .list_item {
    color: #fff;
    line-height: 46px;
    font-size: 12px;
    display: block;
    direction: ltr;
    &:after {
      display: block;
      background-color: #323b48;
      height: 1px;
      width: 394px;
      margin-left: -10px;
    }
  }
  .col {
    width: 33%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .change_txt {
    font-size: 12px;
  }
  .white {
    color: #fff;
  }
  .red {
    color: #e6704a;
  }
  .green {
    color: #55af89;
  }
  .yellow {
    color: #faff24;
  }
  .arrow_up {
    display: inline-block;
    background: url(//img.yimutian.com/crm/5bcc315864008157d94971ba38a006de.png)
      center center no-repeat;
    background-size: contain;
    width: 10px;
    height: 10px;
  }
  .arrow_down {
    display: inline-block;
    background: url(//img.yimutian.com/crm/5bcc2ef264008157d9496fcb98d9d28b.png)
      center center no-repeat;
    background-size: contain;
    width: 10px;
    height: 10px;
  }
  .arrow_keep {
    display: inline-block;
    background: url(//img.yimutian.com/crm/5bcc2f396ef1433be54b5e433e9fa23c.png)
      center center no-repeat;
    background-size: contain;
    width: 10px;
    height: 10px;
  }
  .col_rank {
    .arrow_up {
      transform: translateY(2px);
    }
    .arrow_down {
      transform: translateY(2px);
    }
    .arrow_keep {
      transform: translateY(2px);
    }
  }
  .rank_txt {
    display: inline-block;
    width: 18px;
    line-height: 18px;
    font-size: 10px;
    background: #ec6446;
    border-radius: 3px;
    text-align: center;
    margin-right: 8px;
  }
  .rate_txt {
    width: 30px;
  }
  .col {
    .arrow_up {
      margin-left: 6px;
    }
    .arrow_down {
      margin-left: 6px;
    }
    .arrow_keep {
      margin-left: 6px;
    }
  }
}
</style>
